import PropTypes from "prop-types"
import "../style.css"
import { JobbinInputWhiteProps } from "./model"
import { useState } from "react"

export const JobbinInputWhite = (props: JobbinInputWhiteProps) => {
    const [passwordType, setPasswordType] = useState("password")

    const onPasswordToggle = () => {
        setPasswordType((prev) => (prev === "password" ? "text" : "password"))
    }

    return (
        <div className="relative flex w-full flex-col">
            {props.label ? (
                <label
                    className="jobbin-input-label mb-3 text-start text-sm sm:text-base text-figmaDarkGray"
                    htmlFor={props.name}
                >
                    {props.label}
                </label>
            ) : null}

            <input
                onChange={props.onChange}
                id={props.name}
                className={
                    props.classNames
                        ? `jobbin-input w-full rounded-[12px] px-5 py-[14px] text-[16px] text-figmaBlack ${props.classNames}`
                        : "jobbin-input w-full rounded-[12px] px-5 py-[14px] text-[16px] text-figmaBlack"
                }
                style={
                    props.iconStart
                        ? {
                            backgroundImage: `url(/images/${props.iconStart})`,
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "left 20px center",
                            paddingLeft: "52px",
                        }
                        : props.iconEnd
                            ? {
                                backgroundImage: `url(/images/${props.iconEnd})`,
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "right 20px center",
                                paddingRight: "52px",
                            }
                            : {}
                }
                type={props.type === "password" ? passwordType : props.type}
                placeholder={props.placeholder}
                name={props.name}
                maxLength={props.maxLength}
            />

            {props.type === "password" ? (
                <button
                    type="button"
                    onClick={onPasswordToggle}
                    className="absolute right-3 top-[44px] flex h-10 w-10 items-center justify-center cursor-pointer"
                    aria-label={passwordType === "password" ? "Arată parola" : "Ascunde parola"}
                >
                    <img
                        src="/images/ic-eye-password.svg"
                        alt="Toggle password visibility"
                        className="h-5 w-5"
                    />
                </button>
            ) : null}
        </div>
    )
}

JobbinInputWhite.propTypes = {
    placeholder: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
}